import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioPool } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const usePatchScenarioPool = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );
  const { mutate: updateScenarioPool, isPending } = useAppMutation([QueryKey.PATCH_SCENARIO_POOL], {
    mutationFn: ({
      data,
      scenarioId,
      poolId,
    }: {
      data: CreateScenarioPool;
      poolId: string;
      scenarioId: string;
    }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'pools', poolId],
        },
        {
          body: data,
        },
      ),
    onSuccess: () => {
      invalidateCalculationQueries();
    },
  });
  return { updateScenarioPool, isPending };
};
